
export let Images360 = [
    {
        "id": 1,
        "contents": 10,
        "categoryName":{
            'en': "Adventure",
            'de': "Abenteuer",
            'pt': "Aventura",
            "fr": "Adventure",
            "be": "Adventure",
            "tr": "Adventure",
            "cy": "Авантура",
            "it": "Avventura",
            "el": "Περιπέτεια",
            "pl": "Przygoda"
        },
        "name": "Adventure",
        "images": [
            {
                "id": 1,
                "name": {
                    'en':"360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                    'pt': "360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                    "fr": "360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                    "be": "360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                    "tr": "360, (l-r) Ha Ling Zirvesi Su taşıyan baraj gölü",
                    "pl": "360, (l-r) Szczyt Ha Ling, zbiornik wodny transportujący wodę"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/1.jpg"
            },
            {
                "id": 2,
                "name": {
                    'en': "Backpacker on top of a rock fall at dawn",
                    'pt': "Backpacker on top of a rock fall at dawn",
                    "fr": "Backpacker on top of a rock fall at dawn",
                    "be": "Backpacker on top of a rock fall at dawn",
                    "tr": "Şafak vakti bir kayanın zirvesindeki sırt çantalı gezgin",
                    "pl": "Backpacker na szczycie skały o świcie"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/2.jpg"
            },
            {
                "id": 3,
                "name": {
                    'en': "Female inside the crack in the ice glaciers Iceland",
                    'pt': "Female inside the crack in the ice glaciers Iceland",
                    "fr": "Female inside the crack in the ice glaciers Iceland",
                    "be": "Female inside the crack in the ice glaciers Iceland",
                    "tr": "Bir buzul çatlağının içindeki kadın İzlanda",
                    "pl": "Kobieta wewnątrz pęknięcia w lodowcach Islandii"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/3.jpg"
            },
            {
                "id": 4,
                "name": {
                    'en': "Man at tent on stone beach on shore of Lake Baikal at night.",
                    'pt': "Man at tent on stone beach on shore of Lake Baikal at night.",
                    "fr": "Man at tent on stone beach on shore of Lake Baikal at night.",
                    "be": "Man at tent on stone beach on shore of Lake Baikal at night.",
                    "tr": "Baykal Gölünün kayalık kıyısında gece vakti çadırdaki adam",
                    "pl": "Mężczyzna w namiocie na kamiennej plaży nad brzegiem jeziora Bajkał w nocy."
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/4.jpg"
            },
            {
                "id": 5,
                "name": {
                    'en': "Man skier freerider standing at top of ridge",
                    'pt': "Man skier freerider standing at top of ridge",
                    "fr": "Man skier freerider standing at top of ridge",
                    "be": "Man skier freerider standing at top of ridge",
                    "tr": "Bir sırtın tepesinde duran kar kayaklı adam",
                    "pl": "Mężczyzna narciarz freeride stojący na szczycie grzbietu"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/5.jpg"
            },
            {
                "id": 6,
                "name": {
                    'en': "Man stands by lake in red jacket in cloudy weather",
                    'pt': "Man stands by lake in red jacket in cloudy weather",
                    "fr": "Man stands by lake in red jacket in cloudy weather",
                    "be": "Man stands by lake in red jacket in cloudy weather",
                    "tr": "Bulutlu havada kırmızı ceketle göle karşı duran adam",
                    "pl": "Mężczyzna stoi nad jeziorem w czerwonej kurtce w pochmurną pogodę"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/6.jpg"
            },
            {
                "id": 7,
                "name": {
                    'en': "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                    'pt': "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                    "fr": "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                    "be": "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                    "tr": "Mercan kayalıklı tropikal denizi keşfeden kadın serbest dalışçının kusursuz panoraması",
                    "pl": "Bezszwowa panorama freediverki eksplorującej tropikalne morze z rafą koralową"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/7.jpg"
            },
            {
                "id": 8,
                "name": {
                    'en': "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                    'pt': "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                    "fr": "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                    "be": "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                    "tr": "Endonezya, Bali'deki iki kadın yürüyüşçünün kusursuz panoraması",
                    "pl": "Bezszwowa panorama dwóch kobiet wycieczkowiczów na Bali, Indonezja"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/8.jpg"
            },
            {
                "id": 9,
                "name": {
                    'en': "Swiss Mountain Lake nature Drone drone Air",
                    'pt': "Swiss Mountain Lake nature Drone drone Air",
                    "fr": "Swiss Mountain Lake nature Drone drone Air",
                    "be": "Swiss Mountain Lake nature Drone drone Air",
                    "tr": "İsveç Dağ Gölünün havadan doğal Drone görünümü",
                    "pl": "Natura szwajcarskiego jeziora górskiego Drone dron Powietrze"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/9.jpg"
            },
            {
                "id": 10,
                "name": {
                    'en': "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    'pt': "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "fr": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "be": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "tr": "Ukrayna Karpatları'ndaki Osmoloda köyündeki dağların vahşi ormanı",
                    "pl": "Dziki las w górach ukraińskich Karpat, we wsi Osmołoda"
                },
                "desc": "",
                "ImageUrl": "./img/images360/Adventure/10.jpg"
            }
            

        ]
    },
    {
        "id": 2,
        "contents": 10,
        "categoryName":{
            'en': "Cities",
            'de': "Städte",
            'fr': "Villes",
            'pt': "Cidades",
            "be": "Cities",
            "tr": "Cities",
            "cy": "Градови",
            "it": "Città",
            "el": "Πόλεις",
            "pl": "Miasta"

        },
        "name": "Cities",
        "images": [
            {
                "id": 1,
                "name": {
                    'en': "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    'pt': "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "fr": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "be": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                    "tr": "Ukrayna Karpatları'ndaki Osmoloda köyündeki dağların vahşi ormanı",
                    "pl": "Dziki las w górach ukraińskich Karpat, we wsi Osmołoda"
                },
                "name": "360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/1.jpg"
            },
            {
                "id": 2,
                "name": "Backpacker on top of a rock fall at dawn",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/2.jpg"
            },
            {
                "id": 3,
                "name": "Female inside the crack in the ice glaciers Iceland",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/3.jpg"
            },
            {
                "id": 4,
                "name": "Man at tent on stone beach on shore of Lake Baikal at night.",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/4.jpg"
            },
            {
                "id": 5,
                "name": "Man skier freerider standing at top of ridge",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/5.jpg"
            },
            {
                "id": 6,
                "name": "Man stands by lake in red jacket in cloudy weather",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/6.jpg"
            },
            {
                "id": 7,
                "name": "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/7.jpg"
            },
            {
                "id": 8,
                "name": "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/8.jpg"
            },
            {
                "id": 9,
                "name": "Swiss Mountain Lake nature Drone drone Air",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/9.jpg"
            },
            {
                "id": 10,
                "name": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                "desc": "",
                "ImageUrl": "./img/images360/Cities/10.jpg"
            }
        ]
    },
    {
        "id": 3,
        "contents": 10,
        "categoryName":{
            'en': "Nature",
            'de': "Natur",
            'pt': "Natureza",
            "fr": "Nature",
            "be": "Nature",
            "tr": "Nature",
            "cy": "Природа",
            "it": "Natura",
            "el": "Φύση",
            "pl": "Natura"

        },
        "name": "Nature",
        "images": [
            {
                "id": 1,
                "name": "360, (l-r) Ha Ling Peak, Reservoir of water that transports water",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/1.jpg"
            },
            {
                "id": 2,
                "name": "Backpacker on top of a rock fall at dawn",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/2.jpg"
            },
            {
                "id": 3,
                "name": "Female inside the crack in the ice glaciers Iceland",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/3.jpg"
            },
            {
                "id": 4,
                "name": "Man at tent on stone beach on shore of Lake Baikal at night.",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/4.jpg"
            },
            {
                "id": 5,
                "name": "Man skier freerider standing at top of ridge",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/5.jpg"
            },
            {
                "id": 6,
                "name": "Man stands by lake in red jacket in cloudy weather",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/6.jpg"
            },
            {
                "id": 7,
                "name": "Seamless panorama of the lady freediver exploring the tropical sea with coral reef",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/7.jpg"
            },
            {
                "id": 8,
                "name": "Seamless panorama of the two ladies hikers in Bali, Indonesia",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/8.jpg"
            },
            {
                "id": 9,
                "name": "Swiss Mountain Lake nature Drone drone Air",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/9.jpg"
            },
            {
                "id": 10,
                "name": "Wild forest in the mountains of Ukrainian Carpathians, in the village of Osmoloda",
                "desc": "",
                "ImageUrl": "./img/images360/Nature/10.jpg"
            }
            

        ]
    }
];


// WEBPACK FOOTER //
// ./src/constants/images360.js